type ApolloGraphQLErrorExtensionsLike = Record<string, unknown> & {
  code?: string;
  details?: string;
  exception?: {
    code?: number;
  };
};

export type ApolloGraphQLErrorLike = {
  extensions?: ApolloGraphQLErrorExtensionsLike;
  message: string;
  path?: ReadonlyArray<string | number>;
  type?: string;
};

type ApolloNetworkErrorLike = Error & {
  statusCode?: number;
};

export type ApolloErrorLike = Error & {
  errors?: ReadonlyArray<ApolloGraphQLErrorLike>;
  extraInfo?: unknown;
  graphQLErrors?: ReadonlyArray<ApolloGraphQLErrorLike>;
  networkError?: ApolloNetworkErrorLike | Error | null;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const isApolloGraphQLErrorLike = (value: unknown): value is ApolloGraphQLErrorLike =>
  isRecord(value) && typeof value.message === 'string';

const getGraphQLErrorArray = (
  value: unknown,
): ReadonlyArray<ApolloGraphQLErrorLike> | undefined => {
  if (!Array.isArray(value)) {
    return undefined;
  }

  return value.filter(isApolloGraphQLErrorLike);
};

export const getApolloGraphQLErrors = (
  error: unknown,
): ReadonlyArray<ApolloGraphQLErrorLike> | undefined => {
  if (!isRecord(error)) {
    return undefined;
  }

  return getGraphQLErrorArray(error.graphQLErrors) ?? getGraphQLErrorArray(error.errors);
};
